var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3531 11.4582L12.3538 10.1727C12.2257 10.1181 12.0833 10.1066 11.948 10.14C11.8128 10.1733 11.6921 10.2496 11.604 10.3575L10.2757 11.9804C8.19111 10.9975 6.51349 9.31988 5.53062 7.23528L7.15347 5.90701C7.26157 5.81909 7.33809 5.69834 7.37143 5.56304C7.40477 5.42774 7.39312 5.28527 7.33825 5.15718L6.05283 2.15786C5.9926 2.01979 5.88609 1.90706 5.75165 1.8391C5.61721 1.77115 5.46328 1.75224 5.31639 1.78562L2.5313 2.42834C2.38969 2.46104 2.26333 2.54078 2.17287 2.65454C2.0824 2.7683 2.03317 2.90937 2.0332 3.05471C2.0332 9.92369 7.60069 15.4805 14.459 15.4805C14.6043 15.4806 14.7455 15.4314 14.8593 15.3409C14.9731 15.2504 15.0529 15.124 15.0856 14.9824L15.7283 12.1973C15.7615 12.0497 15.7422 11.8951 15.6737 11.7602C15.6052 11.6253 15.4919 11.5185 15.3531 11.4582Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone_icon.ce72e9df90420f6cab4cf4b324248326.svg";
export { ForwardRef as ReactComponent };